import { Dropdown, ResponsiveMode } from '@fluentui/react';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { EUICurrencyField } from '../EUI/EUICurrencyField';
import { EUINumericField } from '../EUI/EUINumericField';
import { EUIPercentField } from '../EUI/EUIPercentageField';

const TextFieldHonoraires = (props) => {

    // CONTEXTS

    // PROPS
    const {
        disabled = false,
        label = "Honoraires de commercialisation",
        readOnly = false,
        value = "",
        /* --- */
        onChange = (event, newValue) => null,
        onDelayedChange = (event, newValue) => null
    } = props;

    // CONSTANTES

    // STATES
    const [_suffix, _setSuffix] = useState("%");

    // REFS

    // MEMOS
    const _displayedValue = useMemo(() => {
        let displayedValue = value;
        if (!!displayedValue) {
            displayedValue = displayedValue.replace(/%|€/g, ""); // Suppression du suffixe
            displayedValue = displayedValue.replace(/,/g, "."); // Correction du séparateur décimal
            displayedValue = displayedValue.trim(); // Suppression des espaces en début et fin
        }
        return displayedValue;
    }, [value]);

    const _styles = useMemo(() => {
        return {
            dropdown: {
                root: { width: 60 },
                title: { backgroundColor: "transparent", border: "none" }
            },
            textfield: { suffix: { padding: 0 } }
        };
    }, []);

    // METHODS
    const _getFullValue = useCallback((value) => {
        value = value || _displayedValue;
        return !!value ? `${value} ${_suffix}` : "";
        return !!value ? `${value.replace(/\./g, ",")} ${_suffix}` : "";
    }, [_displayedValue, _suffix]);

    const _onChange = useCallback((event, newValue) => {
        const returnedValue = _getFullValue(newValue);
        if (typeof onChange === "function")
            onChange(event, returnedValue);
    }, [_getFullValue, onChange]);

    const _onDelayedChange = useCallback((event, newValue) => {
        const returnedValue = _getFullValue(newValue);
        if (typeof onDelayedChange === "function")
            onDelayedChange(event, returnedValue);
    }, [_getFullValue, onDelayedChange]);

    const _onRenderSuffix = useCallback(() =>
        <Dropdown
            disabled={disabled || readOnly}
            onChange={(event, option) => _setSuffix(option.key)}
            options={[{ key: "%", text: "%" }, { key: "€", text: "€" }]}
            responsiveMode={ResponsiveMode.Large} // Empêche la Dropdown de s'ouvrir dans un panel (sur petits écrans)
            selectedKey={_suffix}
            styles={_styles.dropdown}
        />,
        [_styles, _suffix, disabled, readOnly]
    );

    // EFFECTS (ComponentDidMount + ComponentDidUpdate)
    useEffect(() => {
        if (!!value) {
            const suffix = value.search(/€/g) >= 0 ? "€" : "%";
            _setSuffix(suffix);
        }
    }, [value]);

    useEffect(() => {
        _onDelayedChange();
    }, [_suffix]);

    // RENDER
    let Component = EUINumericField;
    if (_suffix === "€") Component = EUICurrencyField;
    else if (_suffix === "%") Component = EUIPercentField;
    return <Component
        {...props}
        label={label}
        min={0}
        onChange={(event, newValue) => _onChange(event, newValue)}
        onDelayedChange={(event, newValue) => _onDelayedChange(event, newValue)}
        onRenderSuffix={_onRenderSuffix}
        styles={_styles.textfield}
        value={_displayedValue}
    />;

};

export default TextFieldHonoraires;